export const getCopiedAssignmentInitialState = (assignment) => ({
  ...assignment,
  content_id: null,
  copied_from_assignment: assignment.content_id,
  is_draft: true,
});
